/**
 * 共用接口文档地址
 */

import api from "@/api/axiosApi";

const apiList = {
  // 分页查询活动发布
  activityPage(data) {
    return api(
      {
        url: "/biz/activity/page",
        method: "post"
      },
      data || {}
    );
  },
  // 新增活动发布
  activityAdd(data) {
    return api(
      {
        url: "/biz/activity",
        method: "post"
      },
      data || {}
    );
  },
  // 修改活动发布
  activityUpdate(data) {
    return api(
      {
        url: "/biz/activity",
        method: "put"
      },
      data || {}
    );
  },
  // 活动详情查询
  activityDetail(data) {
    return api(
      {
        url: `/biz/activity/${data.id}`,
        method: "get"
      },
      data || {}
    );
  },
  // 删除活动
  activityDelete(data) {
    return api(
      {
        url: `/biz/activity/${data.id}`,
        method: "delete"
      },
      data || {}
    );
  },
  // 党员管理
  // 党员管理分页列表
  partyMemberPage(data) {
    return api(
      {
        url: `/biz/partyMember/page`,
        method: "post"
      },
      data || {}
    );
  },
  // 党员管理新增
  partyMemberAdd(data) {
    return api(
      {
        url: `/biz/partyMember`,
        method: "post"
      },
      data || {}
    );
  },
  // 党员管理修改
  partyMemberUpdate(data) {
    return api(
      {
        url: `/biz/partyMember`,
        method: "put"
      },
      data || {}
    );
  },
  // 党员信息详情查询
  partyMemberDetail(data) {
    return api(
      {
        url: `/biz/partyMember/${data.id}`,
        method: "get"
      },
      data || {}
    );
  },
  // 党员信息删除
  partyMemberDel(data) {
    return api(
      {
        url: `/biz/partyMember/${data.id}`,
        method: "delete"
      },
      data || {}
    );
  },
  // 批量导入
  partyMemberImport(data) {
    return api(
      {
        url: "/biz/partyMember/import",
        method: "post"
      },
      data || {}
    );
  },
  // 流动党员
  // 流动党员分页查询
  partyMemberFlowPage(data) {
    return api(
      {
        url: "/biz/partyMemberFlow/page",
        method: "post"
      },
      data || {}
    );
  },
  // 流动党员管理新增
  partyMemberFlowAdd(data) {
    return api(
      {
        url: `/biz/partyMemberFlow`,
        method: "post"
      },
      data || {}
    );
  },
  // 流动党员管理修改
  partyMemberFlowUpdate(data) {
    return api(
      {
        url: `/biz/partyMemberFlow`,
        method: "put"
      },
      data || {}
    );
  },
  // 流动党员信息详情查询
  partyMemberFlowDetail(data) {
    return api(
      {
        url: `/biz/partyMemberFlow/${data.id}`,
        method: "get"
      },
      data || {}
    );
  },
  // 流动党员信息删除
  partyMemberFlowDel(data) {
    return api(
      {
        url: `/biz/partyMemberFlow/${data.id}`,
        method: "delete"
      },
      data || {}
    );
  },
  // 党费缴纳
  // 党费缴纳列表查询
  groupMemPayPage(data) {
    return api(
      {
        url: "/biz/groupMemPay/page",
        method: "post"
      },
      data || {}
    );
  },
  // 生成团费缴费详情
  createPayDetail(data) {
    return api(
      {
        url: "/biz/groupMemPay/createPayDetail",
        method: "post"
      },
      data || {}
    );
  },
  // 党费缴纳批量通知
  handleBatchNotice(data) {
    return api(
      {
        url: "/biz/groupMemPay/handleBatchNotice",
        method: "post"
      },
      data || {}
    );
  },
  // 党费缴纳批量缴纳
  handleBatchPay(data) {
    return api(
      {
        url: "/biz/groupMemPay/handleBatchPay",
        method: "post"
      },
      data || {}
    );
  },
  // 党员发展
  // 党员发展总览
  partyDevelopPreivew(data) {
    return api(
      {
        url: "/biz/partyDevelop/detail",
        method: "post"
      },
      data || {}
    );
  },
  // 党员发展分页查询
  partyDevelopPage(data) {
    return api(
      {
        url: "/biz/partyDevelop/page",
        method: "post"
      },
      data || {}
    );
  },
  // 党员发展详情
  partyDevelopDetail(data) {
    return api(
      {
        url: `/biz/partyDevelop/${data.id}`,
        method: "get"
      },
      data || {}
    );
  },
  // 党员发展删除
  partyDevelopDelete(data) {
    return api(
      {
        url: `/biz/partyDevelop/${data.id}`,
        method: "delete"
      },
      data || {}
    );
  },
  // 党员发展新增
  partyDevelopAdd(data) {
    return api(
      {
        url: "/biz/partyDevelop",
        method: "post"
      },
      data || {}
    );
  },
  // 党员发展修改
  partyDevelopUpdate(data) {
    return api(
      {
        url: "/biz/partyDevelop",
        method: "put"
      },
      data || {}
    );
  },
  // 分页查询通知
  noticePage(data) {
    return api(
      {
        url: "/biz/notice/page",
        method: "POST"
      },
      data || {}
    );
  },
  // 查询通知详情
  noticeDetail(data) {
    return api(
      {
        url: `/biz/notice/${data.id}`,
        method: "GET"
      },
      data || {}
    );
  },
  // 查询当前账号未读消息数
  unReadCount(data) {
    return api(
      {
        url: "/biz/notice/unReadCount",
        method: "post"
      },
      data || {}
    );
  },
  // 查询文章信息
  postDetail(id) {
    return api(
      {
        url: "/biz/post/" + id,
        method: "get"
      },
      {}
    );
  },
  // 分页查询任务
  partyTaskPage(data) {
    return api(
      {
        url: "/biz/partyTask/page",
        method: "POST"
      },
      data || {}
    );
  },
  // 根据任务id分页查询任务流程
  partyTaskFlowPage(data) {
    return api(
      {
        url: "/biz/partyTaskFlow/page",
        method: "POST"
      },
      data || {}
    );
  },
  // pdf转图片
  commonPdfToImg(data) {
    return api(
      {
        url: "/biz/system/common/pdfToImg",
        method: "POST"
      },
      data || {}
    );
  },
  // app端文章详情
  appNewDetail(data) {
    return api(
      {
        url: "/biz/post/appNew/" + data,
        method: "get"
      },
      {}
    );
  },
  // 查询最新app版本
  clientVersionGetLatest() {
    return api(
      {
        url: "/biz/clientVersion/getLatest",
        method: "get"
      },
      {}
    );
  },
  // 分页查询文章回复
  articleReplyPage(data) {
    return api(
      {
        url: "/biz/reply/page",
        method: "post"
      },
      data || {}
    );
  },
  // 点赞
  postRecord(data) {
    return api(
      {
        url: "/biz/postRecord",
        method: "post"
      },
      data || {}
    );
  }
};
const partyApiList = { ...apiList };

export default partyApiList;
